import { Link} from '@mui/material';
import {PosProviderDialogProps}from '../Components/PosProviderDialog/PosProviderDialog';

/*
    Available fields: name, posName, website, website2, email, customEmail, phone, phoneAvailability, customContent, noModal
      customEmail and customContent expect HTML between an <li> tag
      noModal is a boolean (true/false)

    Examples

    {
        "name" : "POS Provider Name",
        "posName": "POS name",
        "website": "https://posprovider.website.com.au",
        "email": "support@posprovider.email.com.au",
        "phone": "02 1234 5678",
    },
        {
        "name" : "POS Provider Name",
        "posName": "POS name",
        "noModal": true,
    },
    {
        "name" : "POS Provider Name",
        "posName": "POS name",
        "website": "https://posprovider.website.com.au",
        "email": "support@posprovider.email.com.au",
        "phone": "02 1234 5678",
        "customContent": <li>Custom HTML formatted content here</li>,
        "customEmail": <li>Contact us on <div>101 Fake Street</div><div>Springtown</div></li>,
    },
        {
        "name" : "POS Provider Name",
        "posName": "POS name",
        "website": "https://posprovider.website.com.au",
        "website2":  "https://posprovider.website2.com.au",
        "email": "support@posprovider.email.com.au",
        "phone": "02 1234 5678",
        "phoneAvailability": "8am to 5pm AEST",
        "customContent": <li>See <Link href="https://posprovider.website.com.au/contact-us" target="_blank" rel="noopener noreferrer">https://posprovider.website.com.au/contact-us</Link> for additional contact details</li>,
    },
*/


const POSProvidersList : PosProviderDialogProps[]  = [
    {
        "name" : "ABS POS Systems",
        "posName": "RetailTouch",
        "website": "https://www.retailtouch.com.au",
        "email": "sales@abspos.net",
        "phone": "08 8234 8002",
    },
    {
        "name" : "Beacon Business Systems",
        "posName": "Beacon POS",
        "website": "https://www.beaconsoftware.com.au",
        "email": "support@beaconsoftware.com.au",
        "phone": "03 8807 9989",
    },
    {
        "name" : "Bepoz",
        "posName": "SmartPOS",
        "website": "https://www.bepoz.com.au",
        "email": "sales@bepoz.com.a",
        "phone": "1300 832 876",
    },
    {
        "name" : "Black Label Solutions",
        "posName": "NomadPOS",
        "website": "https://nomadpos.com",
        "email": "support@blss.com.a",
        "phone": "03 8290 2900",
    },
        {
        "name" : "Companion Software",
        "posName": "EDGEPos",
        "website": "https://www.companionsoftware.com.au/products/retail",
        "email": "enquiries@companionsoftware.com.au",
        "phone": "07 3387 038",
    },
    {
        "name" : "FutureNet",
        "posName": "OSPOS, Convenience POS",
        "website": "https://www.futurenet.com.au",
        "email": "support@futurenet.com.au",
        "phone": "02 4761 0666",
    },
    {
        "name" : "GaP Solutions",
        "posName": "EM Cloud, EM POS",
        "website": "https://www.gapsolutions.com.au",
        "email": "help@gapsolutions.com.au",
        "phone": "1300 722 289",
    },
    {
        "name" : "GPK Group",
        "posName": "Merlin POS, Merlin ESP",
        "website": "https://www.gpkgroup.com.au/products-services/retail-solutions/",
        "email": "info@gpkgroup.com.au",
        "phone": "1300 000 475",
    },
    {
        "name" : "H&L",
        "posName": "Exceed POS",
        "website": "https://www.hlpos.com/",
        "email": "sales@hlpos.co",
        "phone": "1800 778 340",
    },
    {
        "name" : "Idealpos",
        "posName": "Idealpos",
        "website": "https://www.idealpos.co",
        "email": "support@idealpos.co",
        "phone": "07 3630 2455",
    },
    {
        "name" : "Independent Solutions",
        "posName": "PROFIT-TRACK",
        "website": "https://www.independentsolutions.com.au",
        "email": "support@independentsolutions.com.au",
        "phone": "1800 020 946",
    },
    {
        "name" : "Kreative Technology",
        "posName": "Konvenience",
        "website": "https://www.kreative.com.au",
        "website2": "https://www.facebook.com/KreativePOS",
        "email": "support@kreative.com.au",
        "phone": "03 9328 8968",
    },
    {
        "name" : "LS Retail",
        "posName": "LS Retail - LS Central",
        "website": "https://www.lsretail.com",
        "website2": "https://www.lsretail.com/contact-us",
        "email": "info@lsretail.com.au",
        "phone": "+354 414 5700",
        "phoneAvailability": "(Iceland Head Office)",
    },
    {
        "name" : "POS Solutions",
        "posName": "PosBrowser",
        "website": "https://www.possolutions.com.au",
        "email": "support@possolutions.com.au",
        "phone": "",
        "customContent": <li>See <Link href="https://www.possolutions.com.au/contact-us" target="_blank" rel="noopener noreferrer">https://www.possolutions.com.au/contact-us</Link> for additional contact details</li>,
    },
    {
        "name" : "Quickfuel",
        "posName": "Quickfuel powered by SwiftPOS",
        "website": "https://www.quickfuel.com.au",
        "email": "support@quickfuel.com.au",
        "phone": "0400 958 725",
        "phoneAvailability": "(24/7 Support)",
    },
    {
        "name" : "SmartFuel",
        "posName": "SmartFuel POS",
        "website": "https://smartfuelpos.com/",
        "email": "support@smartfuelpos.com",
        "phone": "02 8306 4701",
        "phoneAvailability": "(Sales & 24/7 Support)",
    },
        {
        "name" : "Starrtec Solutions",
        "posName": "StarrPOS",
        "website": "https://www.starrtec.com.au",
        "email": "support@starrtec.com.au",
        "phone": "07 3808 9917",
    },
    {
        "name" : "Surefire Systems",
        "posName": "Surefire POS",
        "website": "https://www.surefiresystems.com",
        "email": "support@surefiresystems.com",
        "phone": "1300 724 667",
    },
        {
        "name" : "SwiftPOS",
        "posName": "SwiftPOS",
        "website": "https://www.swiftpos.com.au",
        "email": "support@swiftpos.com.au",
        "phone": "07 3351 8777",
    },
    {
        "name" : "Tower Systems",
        "posName": "Retailer",
        "website": "https://www.towersystems.com.au",
        "email": "support@towersystems.com.au",
        "phone": "03 9524 8000",
    },
    {
        "name" : "Worldsmart",
        "posName": "SmartRetail",
        "website": "https://www.worldsmart.com.au",
        "email": "help@worldsmart.com.au",
        "phone": "1300 653223",
    },
];

export default POSProvidersList;
